export function SkeletonCard() {
  return (
    <div className="card skeleton-card">
      <span className="skeleton-line w-40" />
      <span className="skeleton-line w-70" />
      <span className="skeleton-line w-55" />
      <span className="skeleton-line w-90" />
    </div>
  );
}

export function SkeletonList({ count = 4 }) {
  return (
    <div className="stack">
      {Array.from({ length: count }).map((_, index) => (
        <SkeletonCard key={index} />
      ))}
    </div>
  );
}
